import { createContext, useContext, useState } from "react";

const PageHeaderContext = createContext({ title: '', subtitle: '', icon: null });
const SetPageHeaderContext = createContext(null);

export const PageHeaderProvider = ({ children }) => {
    const [header, setHeader] = useState({ title: '', subtitle: '', icon: null });
    return (
        <SetPageHeaderContext.Provider value={setHeader}>
            <PageHeaderContext.Provider value={header}>
                {children}
            </PageHeaderContext.Provider>
        </SetPageHeaderContext.Provider>
    );
};

export const usePageHeader = () => useContext(PageHeaderContext);
export const useSetPageHeaderFn = () => useContext(SetPageHeaderContext);
